// extracted by mini-css-extract-plugin
module.exports = {"title":"Description_title__j2Iad"};